import React from 'react';
const textContent = node => React.Children.toArray(node).map(child => {
  if (typeof child === 'string' || typeof child === 'number') return String(child);
  return React.isValidElement(child) ? textContent(child.props.children) : '';
}).join(' ').replace(/\s+/g, ' ').trim();

export default function AdminTable({ label, children }) {
  const sections = React.Children.toArray(children);
  const head = sections.find(child => child.type === 'thead');
  const headerRow = React.Children.toArray(head?.props.children)[0];
  const headers = React.Children.toArray(headerRow?.props.children);
  const labels = headers.map(cell => textContent(cell.props.children).replace(/[↑↓↕]/g, '').trim());
  return <table className="admin-data-table" aria-label={label}>
    <caption className="sr-only">{label}</caption>
    {sections.map(section => {
      if (section.type === 'thead') return React.cloneElement(section, {},
        React.cloneElement(headerRow, {}, headers.map(cell => React.cloneElement(cell, { scope: 'col' }))));
      if (section.type !== 'tbody') return section;
      const rows = React.Children.toArray(section.props.children);
      return React.cloneElement(section, {}, rows.length ? rows.map(row => {
        if (!React.isValidElement(row) || row.type !== 'tr') return row;
        return React.cloneElement(row, {}, React.Children.map(row.props.children, (cell, index) =>
          React.isValidElement(cell) ? React.cloneElement(cell, { 'data-label': cell.props.colSpan ? undefined : labels[index] }) : cell));
      }) : <tr><td colSpan={labels.length || 1} className="table-empty">No records to display.</td></tr>);
    })}
  </table>;
}
